module.exports = __webpack_public_path__ + "img/img-sv388-s.f4bc14e7.png";